import { useMutation } from "@tanstack/react-query";
import { createTradingConnection } from "services";

export const useTradingConnection = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (accountId) => {
      return createTradingConnection(accountId);
    },
    onSuccess,
    onError,
  });
};
